/** Labels and helpers for leave day parts (half-days). */

export const DAY_PART_OPTIONS = [
  { value: "FULL_DAY", label: "Journée complète" },
  { value: "MORNING", label: "Demi-journée matin" },
  { value: "AFTERNOON", label: "Demi-journée après-midi" },
];

export const getDayPartLabel = (dayPart) => {
  const found = DAY_PART_OPTIONS.find((o) => o.value === dayPart);
  return found ? found.label : "Journée complète";
};

export const formatDurationDays = (durationDays) => {
  const n = Number(durationDays);
  if (n === 0.5) return "0,5 j";
  if (Number.isInteger(n)) return `${n} jrs`;
  return `${n} jrs`;
};

export const isHalfDay = (dayPart) =>
  dayPart === "MORNING" || dayPart === "AFTERNOON";

// Status label mapping for French display
export const STATUS_LABELS = {
  "PENDING_MANAGER": "En attente du manager",
  "PENDING_HR": "En attente du RH",
  "APPROVED": "Validée",
  "REJECTED": "Refusée"
};

export const getStatusLabel = (status) => {
  return STATUS_LABELS[status] || status;
};

// Leave types that require attachment
export const ATTACHMENT_REQUIRED_TYPES = [
  "MALADIE",
  "MARIAGE",
  "NOUVEAU_NE",
  "DECES_PROCHE",
  "DECES_FAMILLE"
];

export const requiresAttachment = (leaveTypeCode) => {
  return ATTACHMENT_REQUIRED_TYPES.includes(leaveTypeCode);
};
